#import '../fragment/user.graphql'

mutation saveUserMutation($user: UserInput!, $pageType: UserTypeEnum, $customerId: ID) {
  saveUser(user: $user, pageType: $pageType, customerId: $customerId) {
    ...userFragment
  }
}
